import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Delete2 = function Delete2(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M40 44H8c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4h32c2.2 0 4 1.8 4 4v32c0 2.2-1.8 4-4 4ZM8 6c-1.1 0-2 .9-2 2v32c0 1.1.9 2 2 2h32c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2H8Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "m32.309 17.105-1.414-1.414-15.203 15.203 1.414 1.414L32.31 17.105Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M32.31 30.894 17.105 15.69l-1.414 1.414 15.203 15.203 1.414-1.414Z",
      fill: color
    })]
  });
};
export default Delete2;